var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.263,
    height: 76,
    viewBox: "0 0 93.263 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-money",
    transform: "translate(-431 -1141)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 38,
    cy: 38,
    r: 38,
    transform: "translate(431 1141)",
    fill: "#7c8b29",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-money-bag-3979042",
    transform: "translate(364.185 1139.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M138,57.86a.987.987,0,0,0,.375-.779V51.823l4.469,2.377a.986.986,0,0,0,1.45-.868V41.3a18.743,18.743,0,0,0-11.838-17.411V21.568a2.959,2.959,0,0,0-1.637-2.634l3.542-8.878h0a.943.943,0,0,0-.917-1.312h-7.892a.988.988,0,0,0-.878.543l-1.095,2.18-1.095-2.18a.988.988,0,0,0-.878-.543h-4.932a.987.987,0,0,0-.878,1.43l4.4,8.809h0a2.961,2.961,0,0,0-1.549,2.585v2.318A18.743,18.743,0,0,0,106.809,41.3V55.631a5.919,5.919,0,0,0-1.973,4.932,6.086,6.086,0,0,0,6.126,5.4h15.379a.987.987,0,0,0,.986-.8l.917-4.627,4.765,2.377a.986.986,0,0,0,1.421-.9V57.357l2.722.681A.988.988,0,0,0,138,57.86ZM120.995,10.717l1.707,3.4a.987.987,0,0,0,1.756,0l1.707-3.4h5.82l-3.157,7.892h-6.609l-3.946-7.892Zm-.375,10.851a.987.987,0,0,1,.986-.986H129.5a.986.986,0,0,1,.986.986v1.667a18.21,18.21,0,0,0-9.865,0Zm16.267,27.76a.985.985,0,0,0-.484.848v5.643l-2.722-.71a.98.98,0,0,0-1.223.986v4.321l-4.488-2.239a.992.992,0,0,0-1.411.691l-1.006,5.12h-14.59a4.074,4.074,0,0,1-4.153-3.62,3.946,3.946,0,0,1,1.578-3.482.987.987,0,0,0,.395-.789V41.3a16.77,16.77,0,0,1,33.54,0V51.685l-4.469-2.377a.984.984,0,0,0-.967.02Z",
    transform: "translate(0)",
    fill: "#2b400f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M257.7,222.7a1.973,1.973,0,0,1,1.973,1.973h1.973a3.945,3.945,0,0,0-2.959-3.808V218.75H256.71v2.111a3.946,3.946,0,0,0,.987,7.753,1.973,1.973,0,1,1-1.973,1.973H253.75a3.945,3.945,0,0,0,2.959,3.808v2.111h1.973V234.4a3.946,3.946,0,0,0-.987-7.753,1.973,1.973,0,1,1,0-3.946Z",
    transform: "translate(-132.144 -186.331)",
    fill: "#2b400f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M187.824,183.75a12.824,12.824,0,1,0,9.068,3.756A12.824,12.824,0,0,0,187.824,183.75Zm0,23.675a10.851,10.851,0,1,1,7.673-3.178A10.851,10.851,0,0,1,187.824,207.425Z",
    transform: "translate(-62.272 -155.277)",
    fill: "#2b400f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M398.682,446.25a4.932,4.932,0,1,0,3.488,1.444A4.935,4.935,0,0,0,398.682,446.25Zm0,7.892a2.959,2.959,0,1,1,2.093-.867A2.96,2.96,0,0,1,398.682,454.142Z",
    transform: "translate(-256.36 -388.183)",
    fill: "#2b400f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M468.682,377.365a4.932,4.932,0,1,0-3.488-1.444A4.935,4.935,0,0,0,468.682,377.365Zm0-7.892a2.959,2.959,0,1,1-2.093.867A2.96,2.96,0,0,1,468.682,369.473Z",
    transform: "translate(-318.469 -318.311)",
    fill: "#2b400f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M512.432,463.75a4.932,4.932,0,1,0,3.488,1.444A4.935,4.935,0,0,0,512.432,463.75Zm0,7.892a2.959,2.959,0,1,1,2.093-.867A2.96,2.96,0,0,1,512.432,471.642Z",
    transform: "translate(-357.286 -403.71)",
    fill: "#2b400f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoney);
export default __webpack_public_path__ + "static/media/icon-money.5f9b0459cb2daa69a5969b1ce97aff3e.svg";
export { ForwardRef as ReactComponent };